import React from "react";
import {
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
} from "mdb-react-ui-kit";

import ProjectDetail from "../ProjectDetail/ProjectDetail";
import "./ProjectsSection.css";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { mfmFramedUrl } from "Projects/CC_cubi_clan_project/Utils/MfmService";

const PROJECT_CARD_FORMAT_KEY = "ratio:16:9";

class ProjectsSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProjectId: null,
      selectedProject: null,
      projects: [],
    };
  }

  componentDidMount() {
    this.loadProjects();
  }

  // ⬇️ MINIMO: priorizamos imageBase64 y la convertimos a data URL si hace falta
  transformProjectLite(project) {
    if (!project) return {};
    const id = project.idProyecto;
    const slug = project.slug;
    const title = project.title || project.tittle || project.name || "Proyecto";
    const description = project.description || "";

    let coverImage = null;
    // 1) Imagen principal del proyecto (imageUuid > imageBase64)
    if (project.imageUuid) {
      coverImage = mfmFramedUrl(project.imageUuid, 320, 180, PROJECT_CARD_FORMAT_KEY);
    } else if (project.imageBase64) {
      const b64 = String(project.imageBase64);
      coverImage = b64.startsWith("data:")
        ? b64
        : `data:image/jpeg;base64,${b64}`;
    } else {
      // 2) Fallback: primera foto de la galería si existe
      try {
        if (
          project.gallery &&
          project.gallery.photos &&
          project.gallery.photos.length > 0
        ) {
          coverImage = project.gallery.photos[0];
        }
      } catch (e) {
        coverImage = null;
      }
    }

    return { id, slug, title, description, coverImage, sortOrder: project.sortOrder || 0, ribbonDate: this.getRibbonDate(project) };
  }

  /**
   * From the project's representaciones, pick the best date to show on the ribbon.
   * Today counts as past. If there are future dates (strictly after today),
   * pick the closest future date → green. Otherwise pick the most recent
   * past date → blue.
   * Returns { date, label: "dd/mm/yyyy", isPast } or null.
   */
  getRibbonDate(project) {
    const reps = project.representaciones;
    if (!reps || reps.length === 0) return null;

    const now = new Date();

    let futureDates = [];
    let pastDates = [];

    reps.forEach((r) => {
      (r.fechas || []).forEach((f) => {
        if (!f.startDatetime) return;
        const d = new Date(f.startDatetime);
        if (isNaN(d.getTime())) return;
        const dateOnly = f.startDatetime.substring(0, 10);
        if (d > now) futureDates.push({ raw: dateOnly, d });
        else pastDates.push({ raw: dateOnly, d });
      });
    });

    if (futureDates.length > 0) {
      futureDates.sort((a, b) => a.d - b.d);
      const pick = futureDates[0];
      return { date: pick.raw, label: this.formatDateLabel(pick.raw), isPast: false };
    }
    if (pastDates.length > 0) {
      pastDates.sort((a, b) => b.d - a.d);
      const pick = pastDates[0];
      return { date: pick.raw, label: this.formatDateLabel(pick.raw), isPast: true };
    }
    return null;
  }

  formatDateLabel(dateStr) {
    const parts = dateStr.split("-");
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }

  loadProjects() {
    if (this.props.onLoading) this.props.onLoading(true);
    doFetch("TEAN", "getProyectosLite", { method: "GET" })
      .then((response) => response.json())
      .then((data) => {
        const rows = data && data.DATA ? data.DATA : [];
        const projects = (rows ?? [])
          .filter((p) => String(p?.status).toLowerCase() !== "draft")
          .map((p) => this.transformProjectLite(p))
          .sort((a, b) => {
            const sa = Number(a.sortOrder);
            const sb = Number(b.sortOrder);
            if (Number.isFinite(sa) && Number.isFinite(sb)) return sa - sb;
            return 0;
          });
        this.setState({ projects });
      })
      .catch((error) => {
        console.error(
          "Error al obtener proyectos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        if (this.props.onLoading) this.props.onLoading(false);
      });
  }

  openProject = (slug) => {
    if (!slug) return;
    this.props.onHandleNavLinks({ force: "Projects" }, "/project/" + slug);
  };

  closeProject = () => {
    this.setState({ selectedProjectId: null, selectedProject: null });
  };

  render() {
    if (this.state.selectedProjectId && this.state.selectedProject) {
      return (
        <ProjectDetail
          project={this.state.selectedProject}
          onBack={this.closeProject}
        />
      );
    }
    return (
      <section className="projects-section my-5">
        <h2 className="section-title">Obras</h2>
        {this.state.projects.length === 0 && (
          <p className="text-muted">No hay proyectos disponibles.</p>
        )}
        <MDBRow>
          {this.state.projects.map((project) => (
            <MDBCol md="4" key={project.id} className="mb-4">
              <MDBCard className="h-100 project-card">
                {project.ribbonDate && (
                  <div className={`project-ribbon ${project.ribbonDate.isPast ? "ribbon-past" : "ribbon-future"}`}>
                    <span>{project.ribbonDate.label}</span>
                  </div>
                )}
                {project.coverImage && (
                  <MDBCardImage
                    src={project.coverImage}
                    position="top"
                    alt={project.title}
                    className="projects-image"
                  />
                )}
                <MDBCardBody>
                  <MDBCardTitle>{project.title}</MDBCardTitle>
                  <MDBCardText>
                    {project.description && project.description.length > 100
                      ? `${project.description.substring(0, 97)}...`
                      : project.description}
                  </MDBCardText>
                  <MDBBtn onClick={() => this.openProject(project.slug)}>
                    Ver más
                  </MDBBtn>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          ))}
        </MDBRow>
      </section>
    );
  }
}

export default ProjectsSection;
